import { createFileRoute } from '@tanstack/react-router';
import { AppLayout } from '@/components/app-layout';
import { AuthCheck } from '@/components/auth-check.component';
import { FeatureGate } from '@/components/feature-gate.component';
import { Head } from '@/components/head.component';
import { Feature } from '@/constants/features';
import { AgentsGate } from '@/containers/agents/agents-gate.component';
import { AgentTemplatesPage } from '@/containers/agents/agent-templates-page.component';

// The agent templates, a page of their own like Approvals.
export const Route = createFileRoute('/agents/templates')({
  component: TemplatesRoute,
});

function TemplatesRoute() {
  return (
    <>
      <Head heading='Agents' />
      <AuthCheck>
        <AppLayout variant='full-bleed'>
          <FeatureGate feature={Feature.AGENTS}>
            <AgentsGate>
              <AgentTemplatesPage />
            </AgentsGate>
          </FeatureGate>
        </AppLayout>
      </AuthCheck>
    </>
  );
}
